export const prefixFlexArray = ['start', 'end']
export const prefixSpaceArray = ['around', 'between']

